<template>
    <div>
        <div class="listingPageTitle">
            <h1>Attribute Maintenance</h1>
            <ItemModal ref="modal" :itemName="'Attribute'"
                            :formRows="newFormRows"
                            :saveItemFunction="save"
                            :refreshItemsFunction="loadRecords"></ItemModal>
        </div>
        <div class="searchContainer">
            <div class="formRow"><span class="inputTitle">Search Description: </span><input type="text" v-model="searchText" /></div>
            <div class="formRow"><span class="inputTitle">Active Only: </span><input type="checkbox" v-model="onlyShowActive" /></div>
        </div>
        <hr />
        <ListingTable :columns="columns" :filterCriteria="filterCriteria" :actions="actionMappings" 
            :key="componentKey" :intitializationParameters="{ sortBy: 'id', sortDirection: 'desc' }" />
    </div>
</template>

<script>
import { data } from '../../shared/data';
import ItemModal from '@/components/ItemModal.vue';
import ListingTable from '@/components/shared/ListingTable.vue';
import {sorting} from '../../shared/sorting';

export default {
    name: 'AttributeListing',
    components: { ItemModal, ListingTable },
    data: function() {
        return {
            attributes: [],
            dataTypes: [],
            searchText: '',
            onlyShowActive: true,
            componentKey: 0,
            columns: [ 
                {
                    headerDisplayName: "ID",
                    width: "10%",
                    fieldName: "id"
                },
                {
                    headerDisplayName: "Description",
                    width: "50%",
                    fieldName: "description"
                },
                {
                    headerDisplayName: "Code",
                    width: "30%",
                    fieldName: "code"
                },
                {
                    width: "10%",
                    columnType: "buttons",
                    showDeleteFieldName: "isActive",
                    showUndeleteFieldName: "!isActive",
                    showEditFieldName: "isActive",
                    showListingFieldName: null
                }
            ],
            newFormRows: [
                {
                    name: 'Description',
                    propertyName: 'description',
                    required: true,
                    element: 'textarea',
                    maxLength: 100
                },
                {
                    name: 'Code',
                    propertyName: 'code',
                    required: true,
                    element: 'input',
                    maxLength: 50
                },
                {
                    name: 'Data Type',
                    propertyName: 'dataType',
                    required: true,
                    element: 'select'
                },
                {
                    name: "Replacement String?",
                    propertyName: "useAsReplacementString",
                    required: false,
                    element: 'checkbox'
                }

            ],
            actionMappings: {
                onLoadData: this.loadRecords,
                onDelete: this.deleteRecord, 
                onUndelete: this.reactivateRecord,
                onEdit: this.editRecord
            },
        };
    },
    mounted() {
        this.getDataTypes();
    },
    computed: {
        filterCriteria () {
            var criteria = [];
            if(this.searchText != "") 
                criteria.push( {
                    dataType: "String",
                    fieldName: "description",
                    value: this.searchText
                });

            if(this.onlyShowActive) {
                criteria.push( {
                    dataType: "Boolean",
                    fieldName: "isActive",
                    value: true
                });

            }
            return criteria;
        }
    },
    methods: {
        loadRecords: async function() {
            return await data.getAllAttributes('', false);
        },
        getDataTypes: async function() {
            this.dataTypes = await data.getEnumList("DataTypes");
            this.dataTypes = sorting.sortArray(this.dataTypes, 'displayName', 'asc');
            this.newFormRows.find(row => row.propertyName == 'dataType').selectOptions = this.dataTypes;
        },
        editRecord: async function(values) {
            var editRecord = await data.getAttribute(values.id);  
            this.$refs.modal.editRecord(editRecord.id, editRecord);  
        },
        deleteRecord: async function(values) {
            if(confirm('Are you sure you want to delete this attribute?')) {
                var status = this.processDeactivateResult(await data.deleteAttribute(values.id));
                if(status.success) 
                    values.isActive = false;
            }
        },
        save: async function(saveObject) {
            return await this.save_common(saveObject, true); 
        },
        save_common: async function(saveObject, displaySuccess) {
            var retObject = this.processSaveResult(await data.saveAttribute(saveObject));

            if(retObject.success) {
                if(displaySuccess)
                    this.componentKey++;

                if(retObject.id)
                    saveObject.id = retObject.id;

                return retObject;
                
            }
            else
                return retObject;
        },
        reactivateRecord: async function(values) {
            values.isActive = true;
            var status = await this.save_common(values, false);
            if(!status.success)
                values.isActive = false;
        }
    }
}
</script>

<style scoped>
    .searchContainer {
        text-align: left;
        margin: 20px 50px 25px;
    }
    .searchContainer .formRow {
        margin: 0px 0;
    }
    .inputTitle {
        padding-right: 15px;
       
    }
    .searchContainer button {
        height: 40px;
        width: 250px;
        border-radius: 5px;
        border-color: rgb(239, 239, 239);
        font-size: 16px;
        cursor: pointer;
    }
</style>